<template>
  <div>
    <div class="table-list-block mt-2">
      <div class="row">
        <div class="col-sm-5">
          <span @click="toggle" class="ml-2 mr-2 cursor-pointer" v-if="item.children && item.children.length">
            <font-awesome-icon icon="caret-down" size="lg" v-if="!isOpen" />
            <font-awesome-icon icon="caret-up" size="lg" v-if="isOpen" />
          </span>
          <span v-if="!item.children.length" class="ml-2" style="margin-right:11px;">
            &nbsp;
          </span>
          <router-link
              qid="org-view-page-link"
              :to="{ name: 'maintenance.organizations.view', params: { slug: item.slug }}"
          >
            <font-awesome-icon icon="sitemap"/>
            {{item.name}}
          </router-link>
          <br>
          <span v-if="item.organization_level" class="text-muted" :style="getLevelStyle(item)">
            {{ $t('system.level') }} {{ item.organization_level }}
          </span>
        </div>
        <div class="col-sm-7">
          <div class="float-right text-right" style="width:140px;">
            <span>&nbsp;</span>
            <span v-if="isGranted([permissions.ORGANIZATION_EDIT, permissions.ORGANIZATION_EDIT_OWN], item.created_by) && (!getClient.parent || (getClient.parent && item.partition))"
                  class="btn btn-edit"
                  qid="edit-org-button"
                  @click="showEditTPModal(item)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            <span v-if="isGranted([permissions.ORGANIZATION_DELETE, permissions.ORGANIZATION_DELETE_OWN], item.created_by) && (!getClient.parent || (getClient.parent && item.partition))"
                  class="btn btn-delete"
                  qid="delete-org-button"
                  @click="showConfirmDeleteModal(item)"
            >
              <font-awesome-icon icon="trash-alt"/>
            </span>
          </div>
          <div class="float-right mt-2" style="width:300px;">
            <span class="mr-1" v-for="user in getReducedUsers(item.users)">
              <span qid="profile-photo">
                <Avatar :object="user" size="xs"></Avatar>
              </span>
            </span>
            <span v-if="item.users.length > 3"
                    class="badge cursor-pointer"
                    @click="openUsersModal(item)"
            >
              <font-awesome-icon icon="users"/>
              + {{ item.users.length - 3 }}
            </span>
          </div>

        </div>
      </div>
    </div>

    <OrganizationTreeListViewItem
        v-for="(child, index) in item.children"
        :key="index"
        v-show="isOpen"
        @updateSelected="$emit('updateSelected', $event)"
        @updateList="$emit('updateList', $event)"
        :item="child"
        :style="getStyle(child)"
        :selectedOrganization="selectedOrganization"
    ></OrganizationTreeListViewItem>



    <!-- Delete third party confirm modal template -->
    <b-modal ref="delete-organization" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-org-title">
          {{ $t('maintenance.organizations.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.organizations.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.organizations.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-org-cancel-button"
        >
          {{ $t('maintenance.organizations.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteTP(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-org-submit-button"
                  v-if="isGranted([permissions.ORGANIZATION_DELETE, permissions.ORGANIZATION_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.organizations.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit organization modal template -->
    <b-modal ref="edit-organization" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-org-title">
          {{ $t('maintenance.organizations.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-org-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editTPFormSubmit" qid="edit-org-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-org-name-label">
              {{ $t('maintenance.organizations.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-org-form-name"
              type="text"
              v-model="tpForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.organizations.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-org-description-label">
              {{ $t('maintenance.organizations.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-org-form-description"
              v-model="tpForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.organizations.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="edit-org-organization-level-label">
              {{ $t('maintenance.organizations.create.organization_level_label') }}
            </label>
            <multiselect
                v-model="tpForm.organization_level"
                :options="levelItems"
                :placeholder="$t('maintenance.organizations.create.organization_level_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-org-form-organization-level"
                @select="selectLevel"
                @remove="removeLevel"
            ></multiselect>
          </b-form-group>
          <b-form-group ref="select-link-organization" :class="{'d-none':!showLinkOrganizations}">
            <label qid="edit-org-link-organization-label">
              {{ $t('maintenance.organizations.create.link_organization_label') }}
            </label>
            <multiselect
                v-model="tpForm.link_organization"
                :options="organizations"
                track-by="id"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="debounceOrganizations"
                :placeholder="$t('maintenance.organizations.create.link_organization_placeholder')"
                label="name"
                qid="edit-org-link-organization-select"
            ></multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-p-users-label">
              {{ $t('maintenance.organizations.create.members_label') }}
            </label>
            <multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadUsers"
                track-by="slug"
                :placeholder="$t('maintenance.organizations.create.members_placeholder')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditTPModal"
                    qid="edit-org-cancel-button"
          >
            {{ $t('maintenance.organizations.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="edit-org-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.organizations.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </div>


</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import OrganizationTreeListViewItem from '@/components/organizations/OrganizationTreeListViewItem.vue';
import Avatar from '@/components/Avatar.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';

export default {
  name: 'OrganizationTreeListViewItem',
  data: function() {
    return {
      isOpen: false,
      itemToDelete: {},
      tpForm: {
        name: '',
        description: '',
        organization_level: '',
        link_organization: '',
        client:'',
        users: []
      },
      error: '',
      selectedSort: '',
      selectedDirection: '',
      levelItems: [
        { name: this.$t('system.level') + ' 1', value: '1' },
        { name: this.$t('system.level') + ' 2', value: '2' },
        { name: this.$t('system.level') + ' 3', value: '3' },
        { name: this.$t('system.level') + ' 4', value: '4' },
        { name: this.$t('system.level') + ' 5', value: '5' }
      ],
      organizations: [],
      selectedOrganizations: [],
      filterOpened: false,
      keywordValue: '',
      filters: {
        organization_level: '',
        keywordValue: ''
      },
      showLinkOrganizations: false,
      selected_organization: '',
      loading: true,
      buttonDisabled: false,
      selectedUsers: [],
      loadingItems: false,
      users: [],
      selectedItem: {},
      showUsersModal: false,
      myGuides: [],
    }
  },
  props: {
    item: Object,
    selectedOrganization: Object
  },
  watch: {
    selectedOrganization: function () {

    },
  },
  components: {
    OrganizationTreeListViewItem,
    Avatar,
    ShowMoreModal
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
  },
  methods: {
    toggle: function () {
      this.isOpen = !this.isOpen
    },
    getStyle(object) {
      if (object.organization_level == 1) {
        return 'padding-left:40px;'
      }
      if (object.organization_level == 2) {
        return 'padding-left:40px;'
      }
      if (object.organization_level == 3) {
        return 'padding-left:40px;'
      }
      if (object.organization_level == 4) {
        return 'padding-left:40px;'
      }
      if (object.organization_level == 5) {
        return 'padding-left:40px;'
      }
    },
    getLevelStyle(object) {
      if (object.children && object.children.length) {
        return 'padding-left:49px;'
      } else {
        return 'padding-left:49px;'
      }
    },
    openUsersModal(object) {
      this.selectedItem = object
      this.showUsersModal = true
    },
    closeUsersModal() {
      this.selectedItem = {}
      this.showUsersModal = false
    },
    debounceOrganizations: _.debounce(function(query) {
      this.asyncLoadLinkOrganizations(query)
    }, 400),
    selectLevel(selectedOption) {
      this.tpForm.organization_level = selectedOption
      if (selectedOption && selectedOption.value != 1) {
        this.showLinkOrganizations = true;
      } else {
        this.showLinkOrganizations = false;
      }
      this.asyncLoadLinkOrganizations()
    },
    removeLevel() {
      this.tpForm.link_organization = ''
      this.showLinkOrganizations = false
      this.tpForm.organization_level = ''
    },
    asyncLoadLinkOrganizations(query) {
      let self = this;
      piincHttp.get('organizations', { params:
        {
          smaller_then_organization_level: this.tpForm.organization_level.value,
          keyword: query ? query : undefined,
          exclude_organization: this.selected_organization.id,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.organizations = response.data.items;
        }
      }, function() {});
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-organization'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-organization'].hide()
    },
    showEditTPModal(object) {

      let self = this;
      this.error = ''
      this.selected_organization = object;

      this.loadUsers();

      this.selectedUsers = []
      if (object.users && object.users.length) {
        _.forEach(object.users, function (user) {
          self.selectedUsers.push(user)
        })
      }

      this.tpForm.link_organization = []
      this.tpForm.organization_level = []
      if (object.organization_level) {
        this.tpForm.organization_level = _.find(this.levelItems, function(item) {
          return item.value == object.organization_level;
        });
        this.showLinkOrganizations = object.organization_level == 1 ? false : true;
        this.asyncLoadLinkOrganizations();
        this.tpForm.link_organization = object.linkedOrganization;
      }

      this.tpForm.slug = object.slug;
      this.tpForm.name = object.name;
      this.tpForm.description = object.description;

      this.$refs['edit-organization'].show()
    },
    hideEditTPModal() {
      this.$refs['edit-organization'].hide()
    },
    editTPFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.tpForm.client = this.getClient.slug;
      this.tpForm.organization_level = this.tpForm.organization_level ? this.tpForm.organization_level.value : undefined;
      this.tpForm.link_organization = this.tpForm.link_organization ? this.tpForm.link_organization.id : '';

      this.tpForm.users = [];
      if (this.selectedUsers && this.selectedUsers.length) {
        for (var i = 0; i < this.selectedUsers.length; i++) {
          this.tpForm.users.push(this.selectedUsers[i].id);
        }
      }

      piincHttp.put('organizations/' + this.tpForm.slug, this.tpForm).then(function(response) {
        self.hideEditTPModal();
        self.$emit('updateList')
        self.buttonDisabled = false;
        self.$toastr('success', self.$t('maintenance.organizations.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
          if (error.data.errors.organization_level) {
            self.error += ' ' + error.data.errors.organization_level[0]
          }
        }
      })
    },
    getReducedUsers(users) {
      let reducedUsers = []
      if (users.length > 3) {
        reducedUsers = _.cloneDeep(users);
        reducedUsers = reducedUsers.slice(0, 3);
      } else {
        reducedUsers = users;
      }
      return reducedUsers;
    },
    confirmDeleteTP(object) {
      let self = this;
      piincHttp.delete('organizations/' + object.slug).then(function(response) {
        self.hideConfirmDeleteModal();
        self.$emit('updateList')
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.organizations.delete.success'))
      }, function() {});
    },
    loadUsers(query) {
      let self = this;
      piincHttp.get('users', { params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 50
        }
      }).then(function(response) {
        self.users = response.data.items
        if (self.users && !self.users.length && !query) {
          self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    }
  },
  created () {
    this.isOpen = this.item.organization_level == 1
  }
}
</script>
